/* Landingspagina brochure: inschrijving, herkomst en het Meta Lead-event.

   Over de pixel: de bestaande Meta-pixel van deze winkel draait via Shopify's
   Web Pixel-sandbox (de officiële Facebook-app). Die sandbox is afgeschermd —
   `fbq` uit die omgeving is hier niet bereikbaar, en de app kent alleen
   standaardevents (PageView, ViewContent, Purchase). Lead zit daar niet bij.
   Daarom laden we hier een eigen fbq-instantie voor hetzelfde pixel-ID, maar
   sturen we uitsluitend Lead en nadrukkelijk géén PageView — die stuurt de app
   al. Zo ontstaat er geen dubbeling, en ProfitMetrics (server-side Purchase)
   wordt niet geraakt: dat loopt over een ander event en een ander kanaal. */
(function () {
  var blok = document.querySelector('[data-vcb-brochure]');
  if (!blok) return;

  var form     = blok.querySelector('[data-vcb-lp-form]');
  var input    = blok.querySelector('.vcb-lp__input');
  var knop     = blok.querySelector('[data-vcb-lp-knop]');
  var knoptxt  = blok.querySelector('[data-vcb-lp-knoptekst]');
  var foutvak  = blok.querySelector('[data-vcb-lp-fout]');
  var stapForm = blok.querySelector('[data-vcb-lp-stap="formulier"]');
  var stapDank = blok.querySelector('[data-vcb-lp-stap="bedankt"]');

  var PIXEL = blok.getAttribute('data-pixel');
  var lees = function (naam) { return (blok.getAttribute('data-' + naam) || '').trim(); };

  var bezig = false;
  var leadVerstuurd = false;

  /* ---------- andere formulieren van deze pagina weren ----------
     Klaviyo's algemene kortingspop-up verschijnt na een paar seconden en zou
     hier twee dingen fout doen: de aandacht wegtrekken van de brochure, en de
     bezoeker op de nieuwsbrieflijst zetten in plaats van op de brochurelijst.
     CSS verbergt hem; dit haalt hem weg en heft het scroll-slot op dat hij op
     de body legt. */
  (function weerPopups() {
    function opruimen() {
      document.querySelectorAll('div[class*="kl-private-reset-css"], .klaviyo-form, [data-testid="POPUP"]')
        .forEach(function (el) {
          if (blok.contains(el)) return;          // nooit ons eigen formulier
          if (el.parentNode) el.parentNode.removeChild(el);
        });
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    }
    opruimen();
    if (window.MutationObserver) {
      new MutationObserver(opruimen).observe(document.body, { childList: true, subtree: false });
    }
    // De pop-up verschijnt met vertraging; een paar controles vangen dat af.
    var n = 0;
    var t = setInterval(function () { opruimen(); if (++n > 20) clearInterval(t); }, 500);
  })();

  /* ---------- herkomst vasthouden ---------- */
  // De bezoeker kan de pagina herladen of terugkeren; dan staan de utm's niet
  // meer in de URL. Eenmaal gezien, onthouden voor deze sessie.
  function herkomst() {
    var uit = {};
    var velden = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    var q;
    try { q = new URLSearchParams(window.location.search); } catch (e) { q = null; }

    velden.forEach(function (v) {
      var waarde = q ? q.get(v) : null;
      if (waarde) {
        uit[v] = waarde;
        try { sessionStorage.setItem('vcb_' + v, waarde); } catch (e) {}
      } else {
        try {
          var bewaard = sessionStorage.getItem('vcb_' + v);
          if (bewaard) uit[v] = bewaard;
        } catch (e) {}
      }
    });

    // Meta hangt zijn eigen klik-id aan de link; handig om later te herleiden.
    var fbclid = q ? q.get('fbclid') : null;
    if (fbclid) uit.fbclid = fbclid;
    return uit;
  }

  /* ---------- Meta pixel: alleen laden, niet meten ---------- */
  function pixelKlaar() {
    if (!PIXEL) return false;
    if (window.fbq && window.fbq.__vcbInit) return true;
    if (!window.fbq) {
      /* eslint-disable */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */
    }
    // Bewust geen fbq('track','PageView'): die verzorgt de Shopify-app-pixel al.
    window.fbq('init', PIXEL);
    window.fbq.__vcbInit = true;
    return true;
  }

  /* De site draait Cookiebot. Een marketingpixel mag pas vuren als de bezoeker
     daar toestemming voor heeft gegeven; anders staat er een tracker zonder
     grondslag. Heeft iemand nog niet gekozen, dan wachten we op die keuze en
     sturen we het event alsnog zodra de toestemming binnen is. */
  function magMeten() {
    if (!window.Cookiebot) return true;                 // geen banner actief
    var c = window.Cookiebot.consent;
    return !!(c && c.marketing);
  }

  var wachtendeLead = null;
  function bijToestemming() {
    if (wachtendeLead && magMeten()) {
      var w = wachtendeLead;
      wachtendeLead = null;
      leadVerstuurd = false;        // was aangehouden, niet verstuurd
      stuurLead(w.email, w.extra);
    }
  }
  ['CookiebotOnAccept', 'CookiebotOnConsentReady'].forEach(function (ev) {
    window.addEventListener(ev, bijToestemming);
  });

  function stuurLead(email, extra) {
    if (leadVerstuurd) return;      // één inschrijving is één lead
    if (!magMeten()) {              // bewaren tot er toestemming is
      wachtendeLead = { email: email, extra: extra };
      return;
    }
    leadVerstuurd = true;
    if (!pixelKlaar()) return;

    // Eigen id meesturen zodat Meta kan ontdubbelen als er ooit ook een
    // server-side Lead bijkomt.
    var eventId = 'lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    try {
      window.fbq('track', 'Lead', {
        content_name: 'Brochure aanvraag',
        content_category: 'brochure',
        source: (extra && extra.utm_source) || 'direct'
      }, { eventID: eventId });
    } catch (e) {}
  }

  /* ---------- inschrijven bij Klaviyo ---------- */
  function schrijfIn(email, props) {
    var LIST = lees('list'), COMPANY = lees('company');
    if (!LIST || !COMPANY) {
      return Promise.reject(new Error('lijst-id of publieke sleutel ontbreekt'));
    }
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Brochure landingspagina',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email, properties: props }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: LIST } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status === 202 || r.ok) return true;
      return r.text().then(function (t) { throw new Error('Klaviyo ' + r.status + ': ' + t.slice(0, 160)); });
    });
  }

  function toonFout(tekst) {
    foutvak.textContent = tekst;
    foutvak.hidden = false;
    input.setAttribute('aria-invalid', 'true');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (bezig) return;

    var email = (input.value || '').trim();
    foutvak.hidden = true;
    input.removeAttribute('aria-invalid');

    if (!email || email.indexOf('@') < 1 || email.indexOf('.', email.indexOf('@')) < 0) {
      toonFout('Vul een geldig e-mailadres in.');
      input.focus();
      return;
    }

    bezig = true;
    knop.disabled = true;
    var oudeTekst = knoptxt.textContent;
    knoptxt.textContent = 'Even geduld…';

    var props = herkomst();
    props.brochure_aangevraagd_op = new Date().toISOString();

    schrijfIn(email, props)
      .then(function () {
        // Pas hier: de inschrijving staat vast, dus dit is een echte lead.
        stuurLead(email, props);
        stapForm.hidden = true;
        stapDank.hidden = false;
        stapDank.querySelector('.vcb-lp__titel').setAttribute('tabindex', '-1');
        stapDank.querySelector('.vcb-lp__titel').focus();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch(function (err) {
        bezig = false;
        knop.disabled = false;
        knoptxt.textContent = oudeTekst;
        toonFout('Het versturen lukte niet. Probeer het zo nog eens.');
        if (window.console) console.warn('[brochure]', err);
      });
  });
})();
